import { gql } from "@apollo/client"

export const GET_INIT_BATCH_INFO = gql`
    query getInitBatchInfo {
        availableLanguages {
            code
            name
            id
            voices {
                id
                name
                engine
            }
        }
        getAudioFormats {
            id
            name
            sampleRate
            encoding
            type
        }
    }
`
